import { render } from "./btn-icon.vue?vue&type=template&id=726bfe7b&scoped=true&ts=true"
import script from "./btn-icon.vue?vue&type=script&lang=ts"
export * from "./btn-icon.vue?vue&type=script&lang=ts"

import "./btn-icon.vue?vue&type=style&index=0&id=726bfe7b&lang=scss&scoped=true"

import exportComponent from "/data/build/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-726bfe7b"]])

export default __exports__